var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-layers',{on:{"click":e => _vm.$emit('click', e)}},[_c('font-awesome-icon',{class:_vm.textColor,attrs:{"icon":"circle","size":_vm.size}}),_c('font-awesome-icon',{class:_vm.getCssClasses,attrs:{"transform":_vm.transform,"icon":_vm.icon,"size":_vm.size,"inverse":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }